import { render, staticRenderFns } from "./FundSection.vue?vue&type=template&id=f2f2b73c&scoped=true"
import script from "./FundSection.vue?vue&type=script&lang=js"
export * from "./FundSection.vue?vue&type=script&lang=js"
import style0 from "./FundSection.vue?vue&type=style&index=0&id=f2f2b73c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f2b73c",
  null
  
)

export default component.exports